export default {"src":"/_next/static/media/icon-link.bb405210.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};